export default "__VITE_ASSET__BR6M3oRB__"